<!--
 * @Description:
 * @Author: mdb
 * @Date: 2022-05-23 17:09:56
 * @LastEditTime: 2022-06-06 20:11:22
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <h2>拖拽排序</h2>
      <draggable tag="a-checkbox-group" :list="plainOptions" item-key="id">
        <template #item="{ element }">
          <div>
            <a-checkbox :value="element.id">
              {{ element.name }}
            </a-checkbox>
          </div>
        </template>
      </draggable>
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import draggable from 'vuedraggable'

const plainOptions = ref([
  { id: 1, name: '姓名' },
  { id: 2, name: '年龄' },
  { id: 3, name: '性别' },
  { id: 4, name: '出生日期' },
  { id: 5, name: '兴趣爱好' }
])
</script>
<script lang="ts">
export default { name: 'Example' }
</script>

<style lang="scss" scoped>
:deep(.ant-checkbox-group) {
  width: 100%;
  .ant-checkbox-wrapper {
    position: relative;
    display: flex;
    + .ant-checkbox-wrapper {
      margin-left: 0;
    }
  }
}
</style>
